/**
 * @generated
 * This file was automatically generated and should not be manually edited.
 *
 * Auto-generated enum for: task_relations.relation_type
 *
 * To regenerate: npm run db:codegen
 * Any manual changes will be overwritten on next generation.
 */

/* eslint-disable */
// @ts-nocheck

/**
 * TaskRelationRelationType enum representing allowed values for task_relations.relation_type
 */
export enum TaskRelationRelationType {
  /** Sub Task */
  SUB_TASK = 'sub_task',
  /** Carry Over */
  CARRY_OVER = 'carry_over',
  /** Cohort */
  COHORT = 'cohort',
}
